import HundredBricksAPIError from '../../HundredBricksAPIError';
class RegisterNameError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RegisterNameError', ...args);
    }
}
export default RegisterNameError;
